import React from "react";
import RemoveIcon from "../../../assets/icons/new-modal-delete-icon.svg"
import Button from "../../../components/uiComponent/button/index";
import { StyledModalWrapper } from "./style";

const CustomAntdModal = ({
  visible,
  onSave,
  onCancel,
  children,
  width = 600,
  title = "",
  saveText = "Save",
  cancelText = "Cancel",
  ...rest
}) => {
  return (
    <StyledModalWrapper
      title={title}
      visible={visible}
      onOk={onSave}
      okText={saveText}
      cancelText={cancelText}
      onCancel={onCancel}
      width={width}
      footer={null}
      centered
      {...rest}
    >
      <img src={RemoveIcon} className="close-modal-icon-custom" />
      {children}
      <footer>
        <Button className="outlined m-0" onClick={onCancel} text={cancelText} />
        <Button className="m-0" onClick={onSave} text={saveText} />
      </footer>
    </StyledModalWrapper>
  );
};

export default CustomAntdModal;
